<template>
  <el-dialog title="补偿费用" :visible.sync="dialogFormVisible" width="500px">
    <el-form
      ref="dataForm"
      :model="temp"
      label-position="left"
      label-width="100px"
      style="margin: 0 30px"
      :rules="rules"
    >
      <template>
        <el-form-item label="补偿费用" prop="fee">
          <el-input v-model="temp.fee" :placeholder="placeholder" type="number" />
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取消</el-button>
      <el-button type="primary" @click="saveData">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { setCompensationFee } from '@/api/accountingRecord'

export default {
  name: 'Compensation',
  data() {
    return {
      dialogFormVisible: false,
      temp: { fee: '' },
      placeholder: '请输入金额',
      trip_service_id: '',
      rules: { fee: [{ required: true, message: '必填项不能为空' }] }
    }
  },
  created() {},
  methods: {
    handleCompensationFee(trip_service_id) {
      this.trip_service_id = trip_service_id
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    // 保存
    saveData() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          const trip_service_id = this.trip_service_id
          setCompensationFee({ trip_service_id, fee: this.temp.fee }).then(() => {
            this.$parent.fetchData()
            this.dialogFormVisible = false
            this.$parent.$notify({
              title: '成功',
              message: '修改成功',
              type: 'success'
            })
          })
        }
      })
    }
  }
}
</script>
